<template>
    <div class="flex min-h-screen flex-col">
        <div class="flex grow flex-col p-3 sm:py-6">
            <slot />
        </div>
    </div>
</template>
